export const views = [
  {
    key: 'table',
    name: 'Standings',
  },
  {
    key: 'top-scorers',
    name: 'Top Scorers',
  },
  {
    key: 'matches',
    name: 'Matches',
  },
];
